angular.module('lwNamb').filter('plural', function() {
  return function(text) {
    //Type checking to avoid non-strings
    if (typeof text !== 'string') return text;
    if (text === 'training') return text;
    return text + 's';
  };
});
